import React from "react";
import styled from "styled-components";
import SvgSuccess from "../../../components/SvgAnimations/Success.js";
import Warning from "../../SvgAnimations/Warning.js";

const Content = styled.div`
  span {
    font-size: 40px;
    display: block;
    padding: 5px;
    text-align: center;
    color: #a1a8c1;
  }
  hr {
    opacity: 0.1;
    margin: 0;
  }
  small {
    font-size: 16px;
    display: block;
    text-align: center;
    opacity: 0.6;
    margin-top: 20px;
  }

  .success {
    color: #41c78f !important;
  }
  .warning {
    color: #ffc107 !important;
  }
  .error {
    color: #ff6245 !important;
  }
`;

const Title = styled.h2`
  font-weight: bold;
  font-size: 19px;
  text-align: center;
  font-size: 30px;
  margin-bottom: 20px;
`;

export default function Success(props) {
  return (
    <Content>
      {props.status === "boletoPending" ? (
        <>
          <Warning />
          <Title className="warning">
            A assinatura está pendente, aguardando o pagamento do boleto!
          </Title>
        </>
      ) : props.status === "bankslipWithUrl" ? (
        <>
          <SvgSuccess />
          <Title className="success">
            Boleto gerado com sucesso para a assinatura!
          </Title>
        </>
      ) : (
        <>
          <SvgSuccess />
          {props.status === "trialSuccess" ? (
            <Title className="success">
              A assinatura iniciou o período de teste!
            </Title>
          ) : (
            <Title className="success">
              Parabéns, a assinatura foi atualizada com sucesso!
            </Title>
          )}
        </>
      )}
      {props.status === "bankslipWithUrl" && props.bankslipUrl ? (
        <button
          type="button"
          className="btn btn-primary"
          style={{ width: "100%" }}
          onClick={() =>
            window.open(props.bankslipUrl, "_blank", "noopener,noreferrer")
          }
        >
          ACESSAR BOLETO
        </button>
      ) : (
        <button
          type="button"
          className="btn btn-primary"
          style={{ width: "100%" }}
          onClick={props.close}
        >
          CONTINUAR NAVEGANDO
        </button>
      )}
    </Content>
  );
}
